import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const ROUTE_LABELS: Record<string, string> = {
  '/app/products': 'Products',
  '/app/free-text': 'Free Text',
  '/app/ecommerce': 'eCommerce',
  '/app/campaigns': 'Campaigns',
  '/app/usage-guidelines': 'Usage Guidelines',
};

function getRouteLabel(pathname: string): string {
  for (const [path, label] of Object.entries(ROUTE_LABELS)) {
    if (pathname.startsWith(path)) return label;
  }
  return document.title || 'Page';
}

export function useRouteAnnouncer(): string {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const id = setTimeout(() => {
      const label = getRouteLabel(location.pathname);
      setAnnouncement(`Navigated to ${label}`);
    }, 0);

    return () => {
      clearTimeout(id);
    };
  }, [location.pathname]);

  return announcement;
}
